import { useCallback, useMemo } from "react";

import { createData } from "@api/crud";
import { apiUsersEndpoints } from "@api/Endpoints";

import {
  AddAppRolesRequest,
  AppRolesResponse
} from "../models/app-roles-models";

export function useAddAppRoles() {
  const createCallback = useCallback(
    async (apiUserId: string, applicationId: string, appRoles: string[]) => {
      const url = apiUsersEndpoints.addAppRoles();

      const requestData: AddAppRolesRequest = {
        apiUserId: apiUserId,
        applicationId: applicationId,
        appRoles: appRoles
      };

      return await createData<AddAppRolesRequest, AppRolesResponse>(
        url,
        requestData
      );
    },
    []
  );

  return useMemo(
    () => ({
      addAppRoles: createCallback
    }),
    [createCallback]
  );
}
